import React from "react";
import { Helmet } from "react-helmet";
import FormDocumentosAfiliados from "../../components/paet/FormDocumentosAfiliado";

export default function Documento() {
    return (
        <>
            <Helmet>
                <title>Retiro Enfermos Terminales AFP Modelo | Solicitud de Retiro Enfermos Terminales | AFP Modelo</title>
                <meta name="description" content={``} />
                <meta name="robots" content="noindex, follow" />
            </Helmet>
            <section>
                <div className="container">
                    <div className="card formulario mt-5 mb-5">
                        <div className="card-header">
                            <div className="form-row">
                                <div className="titulo">
                                    Retiro de Pensión Anticipada por Enfermedad Terminal (PAET)
                                </div>
                            </div>
                            <div className="form-row">
                                <div className="subtitulo mt-3">
                                    Adjuntar certificados médicos del afiliado o pensionado
                                </div>
                            </div>
                        </div>
                        <div className="card-body paet">
                            <span>
                                En esta sección deberás adjuntar los certificados y autorización médica según corresponda.
                            </span>
                            <FormDocumentosAfiliados />
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}